export class DatetimeParsers {

    // Example: '2020-04-03T08:12:45.125Z' => '03042020'
    static parseISODateToInputDate = (date) => {
        if ( !date ) return '';
        const year = date.slice(0, 4);
        const month = date.slice(5, 7);
        const day = date.slice(8, 10);
        return `${day}${month}${year}`;
    };

    // Example: '2020-04-03T08:12:45.125Z' => '0812'
    static parseISODateToInputTime = (date) => {
        if ( !date ) return '';
        const hour = date.slice(11, 13);
        const minutes = date.slice(14, 16);
        return `${hour}${minutes}`;
    };

    // Example: '04032020' => '2020-04-03T00:00:00.000Z'
    static parseInputDateToISODate = (date) => {
        if ( !date ) return '';
        const day = date.slice(0, 2);
        const month = date.slice(2, 4);
        const year = date.slice(4);
        return `${year}-${month}-${day}T00:00:00.000Z`;
    };

    // Example: '04032020' + '1212' => '2020-04-03T12:12:00.000Z'
    static parseInputDateAndInputTimeToISODate = (date, time) => {
        if ( !date || !time ) return '';
        const day = date.slice(0, 2);
        const month = date.slice(2, 4);
        const year = date.slice(4);
        const hour = time.slice(0, 2);
        const minutes = time.slice(2);
        return `${year}-${month}-${day}T${hour}:${minutes}:00.000Z`;
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/DatetimeParsers.js